import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { errorMiddleware } from './middlewares';
import {
  cellReducer,
  districtReducer,
  errorReducer,
  genderReducer,
  provinceReducer,
  sectorReducer,
  villageReducer,
  voterReducer
} from './slices';

// Define a persist config
const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['auth']
};

// Combine all reducers into a single root reducer
const rootReducer = combineReducers({
  genders: genderReducer,
  provinces: provinceReducer,
  districts: districtReducer,
  sectors: sectorReducer,
  cells: cellReducer,
  villages: villageReducer,
  voters: voterReducer,
  error: errorReducer
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(errorMiddleware)
});

// Create a persistor
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
